import React from "react";
import "./App.scss";

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import {
  AboutPage,
  AboutProfilePage,
  ColorsPage,
  IllustrationsPage,
  LogoPage,
  PhotoArchive,
  Frontpage,
  TemplatesPage,
  ToneOfVoice,
  TypographyPage,
  ComponentsPage,
  AgderPage,
  InnlandetPage,
  MøreOgRomsdalPage,
  NordlandPage,
  OsloOgVikenPage,
  RogalandPage,
  TrøndelagPage,
  TromsOgFinnmarkPage,
  VestfoldOgTelemarkPage,
  VestlandPage,
  StafPage,
  StorybookPage,
} from "./pages";
import FooterSimple from "./stories/components/FooterSimple.js";
import Navigation from "./Navigation.js";
import OestfoldBuskerudOsloOgAkershusPage from "./pages/logo/OestfoldBuskerudOsloOgAkershusPage.js";

function App() {
  return (
    <Router>
      <Navigation />
      <main id="hovedinnhold" aria-label="hovedinnhold">
        <Switch>
          <Route path="/om-statsforvalteren">
            <AboutPage />
          </Route>
          <Route path="/om-profilen">
            <AboutProfilePage />
          </Route>
          <Route path="/logo">
            <LogoPage />
          </Route>
          <Route path="/farger">
            <ColorsPage />
          </Route>
          <Route path="/typografi">
            <TypographyPage />
          </Route>
          <Route path="/språk">
            <ToneOfVoice />
          </Route>
          <Route path="/mønster">
            <IllustrationsPage />
          </Route>
          <Route path="/maler">
            <TemplatesPage />
          </Route>
          <Route path="/fotoarkiv">
            <PhotoArchive />
          </Route>
          <Route path="/storybook">
            <StorybookPage />
          </Route>
          <Route path="/innholdsmoduler">
            <ComponentsPage />
          </Route>
          <Route path="/logo-agder">
            <AgderPage />
          </Route>
          <Route path="/logo-innlandet">
            <InnlandetPage />
          </Route>
          <Route path="/logo-møre-og-romsdal">
            <MøreOgRomsdalPage />
          </Route>
          <Route path="/logo-nordland">
            <NordlandPage />
          </Route>
          <Route path="/logo-oslo-og-viken">
            <OsloOgVikenPage />
          </Route>
          <Route path="/logo-rogaland">
            <RogalandPage />
          </Route>
          <Route path="/logo-trøndelag">
            <TrøndelagPage />
          </Route>
          <Route path="/logo-troms-og-finnmark">
            <TromsOgFinnmarkPage />
          </Route>
          <Route path="/logo-vestfold-og-telemark">
            <VestfoldOgTelemarkPage />
          </Route>
          <Route path="/logo-vestland">
            <VestlandPage />
          </Route>
          <Route path="/logo-Oestfold-Buskerud-Oslo-og-Akershus">
            <OestfoldBuskerudOsloOgAkershusPage />
          </Route>
          <Route path="/logo-staf">
            <StafPage />
          </Route>
          <Route path="/">
            <Frontpage />
          </Route>
        </Switch>
      </main>
      <FooterSimple
        name="Profilhåndbok"
        text="Profilhåndbok for Statsforvalteren"
        link="Tilgjengelighetserklæring (uustatus.no)"
      />
    </Router>
  );
}

export default App;
